import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const DashboardOverview = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const paymentStatus = new URLSearchParams(location.search).get('payment');

  return (
    <>
      {/* Payment Status Banners */}
      {paymentStatus === 'success' && (
        <div className="bg-green-500/10 border border-green-500/30 text-green-400 p-4 rounded-lg flex items-center gap-3 animate-fade-in mb-6">
          <span className="material-symbols-outlined">check_circle</span>
          <span>Payment session successful! Your order is now pending blockchain confirmation.</span>
        </div>
      )}
      {paymentStatus === 'failed' && (
        <div className="bg-red-500/10 border border-red-500/30 text-red-400 p-4 rounded-lg flex items-center gap-3 animate-fade-in mb-6">
          <span className="material-symbols-outlined">error</span>
          <span>Payment was cancelled or failed. You can retry from your Orders tab.</span>
        </div>
      )}

      {/* Header Row */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-[28px] font-bold text-white mb-1">
            Welcome back, {user?.fullName?.split(' ')[0] || 'Trader'}
          </h1>
          <p className="text-[14px] text-on-surface-variant">
            Manage your purchased EAs and wishlist from one dashboard.
          </p>
        </div>
        <Link to="/marketplace" className="bg-primary text-[#131418] font-bold px-6 py-3 rounded-full text-[14px] hover:shadow-[0_0_15px_rgba(240,185,11,0.4)] hover:-translate-y-0.5 transition-all duration-300">
          Browse Marketplace
        </Link>
      </div>

      {/* Stats Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <Link to="/account/my-eas" className="bg-surface-container border border-white/5 rounded-3xl p-6 shadow-lg flex flex-col justify-between group hover:border-white/10 transition-colors">
          <div className="flex justify-between items-center mb-4 text-on-surface-variant">
            <span className="text-[11px] font-bold tracking-widest uppercase">EA Purchased</span>
            <span className="material-symbols-outlined text-[18px] group-hover:translate-x-1 transition-transform">arrow_forward</span>
          </div>
          <div className="text-[40px] font-bold text-primary leading-none">0</div>
        </Link>
        
        <Link to="/account/wishlist" className="bg-surface-container border border-white/5 rounded-3xl p-6 shadow-lg flex flex-col justify-between group hover:border-white/10 transition-colors">
          <div className="flex justify-between items-center mb-4 text-on-surface-variant">
            <span className="text-[11px] font-bold tracking-widest uppercase">Wishlist Items</span>
            <span className="material-symbols-outlined text-[18px] group-hover:translate-x-1 transition-transform">arrow_forward</span>
          </div>
          <div className="text-[40px] font-bold text-[#20b2aa] leading-none">0</div>
        </Link>
      </div>

      {/* Custom Algo Section */}
      <div className="space-y-4">
        <h2 className="text-[18px] font-bold text-white">My Custom Algo Requests</h2>
        <div className="bg-surface-container-lowest border border-white/5 border-dashed rounded-3xl p-12 text-center flex flex-col items-center justify-center">
          <p className="text-[14px] text-on-surface-variant mb-4">No custom algorithm development projects requested yet.</p>
          <Link to="/custom-ea" className="text-primary font-bold text-[14px] hover:underline flex items-center gap-1 group">
            Request Custom Algo <span className="material-symbols-outlined text-[16px] group-hover:translate-x-1 transition-transform">arrow_right_alt</span>
          </Link>
        </div>
      </div>

      {/* WhatsApp Support Banner */}
      <div className="bg-gradient-to-r from-[#0F2E1B] to-[#0A1A12] border border-[#25D366]/20 rounded-3xl p-8 flex flex-col md:flex-row items-center justify-between gap-6 relative overflow-hidden shadow-lg">
        <div className="absolute top-0 right-0 w-[300px] h-[300px] bg-[#25D366]/10 rounded-full blur-[80px] pointer-events-none"></div>
        <div className="flex items-start gap-4 relative z-10">
          <div className="w-12 h-12 rounded-full bg-[#25D366]/20 flex items-center justify-center shrink-0">
            <span className="material-symbols-outlined text-[#25D366] text-[24px]">chat</span>
          </div>
          <div>
            <h3 className="text-white font-bold text-[18px] mb-2">Need help with your EAs?</h3>
            <p className="text-[13px] text-on-surface-variant leading-relaxed max-w-lg">
              Our support team is on WhatsApp to help you with installation, VPS setup, and configuration — usually replies within minutes.
            </p>
          </div>
        </div>
        <a href="https://wa.me/919426532062?text=Hi!%20I%20need%20VIP%20support%20from%20my%20Account%20Dashboard." target="_blank" rel="noreferrer" className="shrink-0 bg-[#25D366] text-white font-bold px-6 py-3 rounded-xl text-[14px] hover:shadow-[0_0_15px_rgba(37,211,102,0.4)] hover:-translate-y-0.5 transition-all duration-300">
          Chat on WhatsApp
        </a>
      </div>
    </>
  );
};

export default DashboardOverview;
